import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import classNames from "classnames/bind";

import styles from "./NewContent.module.scss";

// components
import { NewNavbar, Section, Footer } from "src/components";
import {
  Events,
  NextEvents,
  BlogSlider,
  FeedSlider,
  VenueSlider,
  CTA,
  Feedback,
} from "../components";

// utils
import { init_categories } from "../data";
import { animateScroll } from "../utils/helper";

// contex
import { UserAuthContext } from "src/context/UserAuthContext";

// networks (api)
import {
  fetchEventByCategoryCache,
  fetchCategoriesCache,
  clearCacheCategory,
} from "src/api/HomeApi";

// custom hooks
import useDidMountEffect from "src/custom_hooks/useDidMountEffect";

const cx = classNames.bind(styles);

const NewContent = () => {
  const { userLocation, staleCategory, setStaleCategory } =
    useContext(UserAuthContext);

  const [eventData, setEventData] = useState(null);
  const [initialRender, setInitialRender] = useState(false);
  const [isFeed, setIsFeed] = useState(true);

  const [currCategory, setCurrCategory] = useState({
    // Categoryid: -1,
    // CategoryName: "Today",
    Categoryid: -3,
    CategoryName: "Feed",
    Discription: "",
  });
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    setInitialRender(true);

    fetchCategoriesCache(0)
      .then((res) => {
        if (res.data.Status) {
          setCategories([...init_categories, ...res.data.Results]);
        } else {
          toast.error(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (staleCategory) {
      setCurrCategory(staleCategory);
    }
  }, [staleCategory]);

  useDidMountEffect(() => {
    if (userLocation) onCategoryChange(currCategory);
  }, [userLocation, initialRender]);

  const onCategoryChange = (_catg) => {
    setCurrCategory(_catg);
    setStaleCategory(_catg);

    // if (_catg.Categoryid === -3) {
    //   setIsFeed(true);
    //   animateScroll();
    //   return;
    // } else {
    //   if (isFeed) setIsFeed(false);
    // }

    setEventData(new Array(4).fill({}));
    animateScroll();

    let params = {
      catgId: _catg.Categoryid,
      lat: userLocation.latitude,
      lng: userLocation.longitude,
      limit: 16,
    };

    fetchEventByCategoryCache(params, false)
      .then((res) => {
        if (res.data.Status) {
          setEventData(res.data.Results);
        } else {
          const id = `/Event${params.catgId}`;
          clearCacheCategory(id);
          setEventData(null);
        }
      })
      .catch((err) => {
        console.log(err);
        setEventData(null);
      });
  };

  return (
    <React.Fragment>
      <NewNavbar
        categories={categories}
        activeCategory={currCategory}
        handleCategoryChange={onCategoryChange}
        isDefault={false}
      />
      <div className={cx("new-content-root")}>
        <Section>
          {/* {
            !isFeed ? (
              <Events
                heading={currCategory.CategoryName}
                items={eventData}
                userLocation={userLocation}
                category={currCategory}
                isTopSpace
              />
            ) : null
            // <FeedSlider />
          } */}
          <Events
            heading={currCategory.CategoryName}
            items={eventData}
            userLocation={userLocation}
            category={currCategory}
            isTopSpace
          />
          <NextEvents
            currCategory={currCategory}
            handleClick={onCategoryChange}
            userLocation={userLocation}
          />

          <VenueSlider />
        </Section>

        <CTA />
        <BlogSlider />
        <Footer />
        {/* remove for now as in production */}
        {/* <Feedback /> */}
      </div>
    </React.Fragment>
  );
};

export default NewContent;
